import api from "../../services/api";
import { toast } from "react-toastify";

export async function listAttendances(props) {
  const { config, me, query } = props;
  const _url_prefix = me?.type === "Formando" ? "trainee/" : "";

  try {
    const { data: _attendances } = await api.get(`${_url_prefix}attendance?${query}`, config);
    const _attendances_return = {
      data: _attendances?.rows?.map(__attendance => ({
        ...__attendance,
        status: formatStatus({
          status: __attendance.status,
          is_urgent: __attendance?.status_urgent && me?.type === "Gestor",
        }),
      })),
      lastPage: _attendances?.pages?.lastPage,
      page: _attendances?.pages?.page,
      perPage: _attendances?.pages?.perPage,
      total: _attendances?.pages?.total,
      filter_count: _attendances?.count,
    };
    return _attendances_return;
  } catch (__error) {
    console.log("__error", __error);
    toast.error("Problemas ao tentar carregar os Atendimentos.");
  }
}

export const formatStatus = props => {
  const { status, is_urgent } = props;
  return status === "resolvido"
    ? "Resolvido"
    : status === "cancelado"
    ? "Cancelado"
    : !!is_urgent
    ? "Urgente"
    : status === "aguardandoEquipe"
    ? "Aguardando Equipe"
    : status === "aguardandoFormando"
    ? "Aguardando Formando"
    : "Aguardando";
};
